import { Box, Paper } from '@mui/material';
import React from 'react';

interface MessageContainerProps {
  isUser: boolean;
  children: React.ReactNode;
}

export const MessageContainer: React.FC<MessageContainerProps> = ({ isUser, children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isUser ? 'flex-end' : 'flex-start',
        mb: 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: isUser ? 'flex-end' : 'flex-start',
          width: '100%',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 2,
            maxWidth: '80%',
            backgroundColor: isUser ? 'rgba(225, 158, 25, 0.07)' : '#ffffff',
            borderRadius: isUser ? '8px 8px 0 8px' : '8px 8px 8px 0',
            borderLeft: isUser ? '2px solid rgba(225, 158, 25, 0.5)' : '2px solid rgba(0, 48, 100, 0.15)',
            border: isUser ? undefined : '1px solid #e8edf2',
            fontFamily: '"Roboto", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
          }}
        >
          {children}
        </Paper>
      </Box>
    </Box>
  );
};